let language = {
    BANK_TRANSFER_INTRO_INSTRUCTIONS:"介绍：",
    BANK_TRANSFER_INTRO_STEP1_TITLE:"付款：",    
    BANK_TRANSFER_INTRO_STEP1_DES1:"请将订单金额",
    BANK_TRANSFER_INTRO_STEP1_DES2:"转账至我们提供的银行账户（详细信息如上）。在转账备注中包含您的订单参考号。",
    BANK_TRANSFER_INTRO_STEP2_TITLE:"确认转账：",
    BANK_TRANSFER_INTRO_STEP2_DES1:"转账后，请输入汇款交易号在 ",
    BANK_TRANSFER_INTRO_STEP2_DES2:"订单详情",
    BANK_TRANSFER_INTRO_STEP2_DES3:"页面。 我们收到付款后（通常在1-2天内），您的订单将进入生产阶段。",
    BANK_TRANSFER_INTRO_STEP3_TITLE:"提醒：",
    BANK_TRANSFER_INTRO_STEP3_DES:"请确保您使用在我们网站上选择的相同货币支付。选择其他货币可能会延迟处理。",
    
};

export { language }